import React from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL HELPERS
import { useUploadHelpers } from '../helpers/useUploadHelpers';

// LOCAL PARTS
import DownPaymentAttachments from '../parts/DownPaymentAttachments';

// STYLES
import styles from './attachmentPlaintext.module.scss';

// MAIN COMPONENT
const AttachmentPlaintext = ({ index, append, ...props }) => useUploadHelpers(
  <Form.PlainText
    schema="dollars"
    input={{
      append: <label className={styles.text}>{append}</label>
    }}
    text={<DownPaymentAttachments />}
    prefix={<DownPaymentAttachments.Button
      index={index}
      icon="attachment"
      link
      className="d-inline-flex"
    />}
    {...props}
  />
, index)

// EXPORT
export default AttachmentPlaintext;
